import { FC } from "react";

import { LINK_ICON_PATHS } from "../utils/icon-paths";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const LinkIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {LINK_ICON_PATHS.map((d, i) => (
      // eslint-disable-next-line react/no-array-index-key -- static list; index is stable
      <path d={d} fill="currentColor" key={i} />
    ))}
  </svg>
);
